module.exports = __webpack_public_path__ + "static/media/studentScoreboardSampleImg.c4f17a3b.png";